import {
  OtherExpenseClassification,
  OtherExpenseClassificationEnum,
  OtherExpenseType,
  OtherExpenseTypeEnum,
  SearchOtherExpenseResponse
} from '../redux/api/otherExpenses/otherExpense.model';

export class ExpenseUtils {
  static getClassificationLabel = (classification: OtherExpenseClassification): string => {
    switch (classification) {
      case OtherExpenseClassificationEnum.COMPANY_CHARGE:
        return 'Company charge';
      case OtherExpenseClassificationEnum.DEDUCT_FROM_PAY:
        return 'Deduct from pay';
      case OtherExpenseClassificationEnum.REIMBURSE:
        return 'Reimburse';
      default:
        return 'Company charge';
    }
  };

  static getTypeLabel = (type: OtherExpenseType): string => {
    switch (type) {
      case OtherExpenseTypeEnum.SCALES:
        return 'Scales';
      case OtherExpenseTypeEnum.TOLLS:
        return 'Tolls';
      case OtherExpenseTypeEnum.TRUCK_PARTS:
        return 'Truck parts';
      case OtherExpenseTypeEnum.TRUCK_WASH:
        return 'Truck wash';
      case OtherExpenseTypeEnum.OTHER:
        return 'Other';
      default:
        return 'Other';
    }
  };

  static getDriverName = (expense: SearchOtherExpenseResponse): string => {
    if (expense.driver) {
      return `${expense.driver.first_name} ${expense.driver.last_name}`;
    }

    return '-';
  };
}
